/* eslint-disable react/require-default-props */
import LoaderSpin from 'components/elements/Loader/LoaderSpin'
import { CHAT_AREA_ID } from 'features/chat/chatConstants'
import { FC, LegacyRef, useMemo } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { groupMsgByDate } from 'features/chat/functions'
import { TGetChatMessage } from 'features/chat/types'
import BaseEmptyBlock from 'components/elements/BaseEmpty/BaseEmptyBlock'
import ChatMessageItem from './ChatMessageItem'

const ChatMessageList: FC<{
 ref?: LegacyRef<HTMLDivElement>
 onScroll?: (e: any) => void
 onReply?: () => void
 id: any
 data?: TGetChatMessage[]
 fetchMore?: () => void
 hasMore?: boolean
 total?: number
 isLoading?: boolean
}> = ({
 onScroll,
 onReply,
 id,
 ref,
 isLoading,
 data,
 fetchMore,
 hasMore,
 total,
}) => {
 const groupedMessages = useMemo(() => groupMsgByDate(data), [data])

 if (isLoading) {
  return <LoaderSpin mtsMode />
 }

 if (!groupedMessages || (groupedMessages && groupedMessages.length === 0)) {
  return <BaseEmptyBlock />
 }

 return (
  <div
   id={CHAT_AREA_ID}
   ref={ref}
   style={{
    display: 'flex',
    flexDirection: 'column-reverse',
   }}
   onScroll={onScroll}
   className="chat-msg-area"
  >
   <InfiniteScroll
    scrollableTarget="chatMsgArea"
    height="100%"
    className="chat-msg-list"
    style={{
     display: 'flex',
     flexDirection: 'column-reverse',
    }}
    inverse
    loader={
     <p className="text-center py-5 m-0">
      <i className="fa fa-spin fa-spinner" />
     </p>
    }
    next={() => {
     fetchMore?.()
    }}
    dataLength={data?.length || 0}
    hasMore={hasMore || false}
    scrollThreshold="100px"
   >
    <div id="lastmessage" />
    {groupedMessages.map((item, index) => (
     <div className="msg-group-blk" key={`${index}-parent`}>
      <div className="msg-group-date">
       <span>{item.date}</span>
      </div>
      {item.messages?.map((message, msgKey) => (
       <ChatMessageItem key={msgKey} onReply={onReply} data={message} id={id} />
      ))}
     </div>
    ))}
   </InfiniteScroll>
  </div>
 )
}

export default ChatMessageList
